export default __webpack_public_path__ + "static/media/reset.63b18527.png";